import GeneralInformationView from './components/general-information-view';

export default GeneralInformationView;
